/**
 * Vacancy API Service
 * Handles all API calls related to vacancies
 */

// Import the fetchWithAuth function
import { fetchWithAuth } from './api';

// API endpoint
const API_URL = '/api/vacancies';

/**
 * Fetch all vacancies
 * @returns {Promise<Array>} Array of vacancy objects
 */
export const fetchVacancies = async () => {
  try {
    const response = await fetchWithAuth(API_URL);
    
    // Let fetchWithAuth handle the 401 errors
    return await response.json();
  } catch (error) {
    console.error('Error fetching vacancies:', error);
    throw error;
  }
};

/**
 * Update vacancy status
 * @param {number} id - Vacancy ID
 * @param {string} status - New status value
 * @returns {Promise<Object>} Updated vacancy object
 */
export const updateVacancyStatus = async (id, status) => {
  try {
    const response = await fetchWithAuth(`${API_URL}/${id}/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status })
    });
    
    return await response.json();
  } catch (error) {
    console.error('Error updating vacancy status:', error);
    throw error;
  }
};

/**
 * Update vacancy construction notes
 * @param {number} id - Vacancy ID
 * @param {string} construction_notes - New construction notes
 * @returns {Promise<Object>} Updated vacancy object
 */
export const updateVacancyConstructionNotes = async (id, construction_notes) => {
  try {
    const response = await fetchWithAuth(`${API_URL}/${id}/construction-notes`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ construction_notes })
    });
    
    return await response.json();
  } catch (error) {
    console.error('Error updating vacancy construction notes:', error);
    throw error;
  }
};

/**
 * Update vacancy leasing notes
 * @param {number} id - Vacancy ID
 * @param {string} leasing_notes - New leasing notes
 * @returns {Promise<Object>} Updated vacancy object
 */
export const updateVacancyLeasingNotes = async (id, leasing_notes) => {
  try {
    const response = await fetchWithAuth(`${API_URL}/${id}/leasing-notes`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ leasing_notes })
    });
    
    return await response.json();
  } catch (error) {
    console.error('Error updating vacancy leasing notes:', error);
    throw error;
  }
}; 